import { ConfigService } from 'app/Core/Abstract/config.service';
import {  Component, OnInit, ViewChild,ViewChildren,QueryList} from "@angular/core";
import { DecimalPipe, DatePipe } from "@angular/common";
import {UntypedFormBuilder,FormGroup,Validators,FormControl,FormArray} from "@angular/forms";
import { Observable , zip } from "rxjs";
import { BaseCRUDComponent } from "./../../Core/Abstract/baseCRUD.component";
import { EventsEmitterService } from "./../../Core/Abstract/emitter.service";
import { LogService } from "./../../Core/Abstract/log.service";
import { VisualsService } from "./../../Core/Abstract/visuals.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDirective } from "ngx-bootstrap/modal";
import { UserListService } from "./userList.service"
import { Location } from '@angular/common';
import { SecurityService } from '../../Core/Security/security.service';
import { MessageService } from '@core/Abstract/newCompany.service';

@Component({
  selector: "userList",
  templateUrl: "./userList.component.html",
//   styleUrls: ["./contactUs.component.css"],
  providers: [UserListService ]
})    
export class UserListComponent extends BaseCRUDComponent<UserListService> implements OnInit {
    @ViewChild('tokenModal', {static: false}) public tokenModal: ModalDirective;
    protected loading: boolean = false;
    userList: any
    statusList = []
    atLeastOneACC: any;
    isBankUserBool : boolean = false;
    footerMsg = "";
  constructor(
    private messageService: MessageService,
    private service: UserListService,
    private eventsEmitterService: EventsEmitterService,
    fb: UntypedFormBuilder,
    logger: LogService,
    visualsService: VisualsService,
    route: ActivatedRoute,
    router: Router,
    private securityService: SecurityService,
    private configService: ConfigService
  ) {
    super(logger, visualsService, route, fb, router);
    this.group = "userList";
    this.statusList = this.visualsService.getLkpFromStorageAsJSON(
      "LKP_REG_USER_S_STATUS",
      true
    );
    
    this.loadVisuals();
    this.isBankUser()
    this.eventsEmitterService.languageChange.subscribe(langId => {
      this.statusList = this.visualsService.getLkpFromStorageAsJSON(
        "LKP_REG_USER_S_STATUS",
        true
      );
        this.loadVisuals();
    })
  }
  ngOnInit(): void {
    this.getUserList();
    this.footerMsg = this.configService.getFooter();
}
protected getUserList() {
    this.loading = true
    this.service.getUserList()
    .subscribe((data) => {
        this.loading = false
        this.userList = data.data;

        localStorage.setItem('userList', JSON.stringify(data.data));

        const buyer = this.userList.find(o => o.isOrigin === 'Y').buyerName;
        this.atLeastOneACC = this.userList.findIndex(e => e.status === 'ACC') === -1 ? null : 'Y';
        localStorage.setItem('byuerName', buyer);
        if (this.userList.length === 1) {
            this.securityService.router.navigate(['/menu/welcomeScreen'],{queryParams: {userId: this.userList[0].userId}});
        }
    },
    error=>{
        this.loading = false
    });
  }
  goToOnboard(id,isOrigin){
    this.securityService.router.navigate(['/menu/welcomeScreen'], {queryParams: {userId: id,isOrigin:isOrigin,acc:this.atLeastOneACC}});
  }

  isBankUser(){
    this.service.getIsBankUser().subscribe((res) => {
        this.loading = false
        this.isBankUserBool = res.data;
        if(this.isBankUserBool){
          this.messageService.sendMessage('Render create company button');
        }
        else{
          this.messageService.clearMessages();
        }
    },
    error=>{
        this.loading = false
    });
  }


  handleInvitationClick(data) {
    if (data.status !== 'PND') {
      this.securityService.router.navigate(['/menu/welcomeScreen'],
          {queryParams: {userId: data.userId, isOrigin: data.isOrigin, acc: this.atLeastOneACC}});
    } else {
      this.tokenModal.show();
    }
  }

  onModalSubmit(data) {
    this.loading = true;
    this.tokenModal.hide();
    this.service.submitMultipleInvitationToken(data.token).subscribe(res => {
      this.loading = false;
      this.securityService.router.navigate(['/menu/welcomeScreen'], {queryParams: {userId: res.data}});
    }, error => {
      LogService.emitAlert({type: 'error', body: this.genericVisuals[error.error.message]});
      this.loading = false;
    });
  }
}

